export default __webpack_public_path__ + "img/ctPUEcnn.ba156a25.svg";